import { render, staticRenderFns } from "./PayStructure.vue?vue&type=template&id=3ef68efb&scoped=true&"
import script from "./PayStructure.vue?vue&type=script&lang=js&"
export * from "./PayStructure.vue?vue&type=script&lang=js&"
import style0 from "./PayStructure.vue?vue&type=style&index=0&id=3ef68efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef68efb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
